import React, {useEffect} from "react";
import SubHeader from "../../components/header/SubHeader";
import {useDispatch, useSelector} from "react-redux";
import {getTableColumns, getTableData} from "../../models/tagModel";
import Table from "../../components/common/table/Table";
import {
    fetchTags,
    resetEditStatus,
    resetUpdateStatus,
    resetCreateStatus,
    resetAssignTagStatus,
    resetUnassignedTagStatus
} from "../../store/tag-slice";
import {useSearchParams} from "react-router-dom";
import ActionButton from "../../components/actions/ActionButton";

const TagView = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const {
        items,
        fetchStatus,
        editStatus,
        createStatus,
        updateStatus,
        assignTagStatus,
        unassignedTagStatus,
        pagination,
        error
    } = useSelector(state => state.tag);

    const userRole = useSelector((state) => state.auth.selectedRole);
    //set initial page and limit
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialLimit = Number(searchParams.get("limit")) || 25;


    useEffect(() => {
        dispatch(fetchTags({
            ...userRole,
            page: initialPage,
            limit: initialLimit
        }));
    }, [dispatch, userRole, initialPage, initialLimit]);

    useEffect(() => {
        if (editStatus === "success") {
            dispatch(resetEditStatus());
        }
    }, [dispatch, editStatus]);

    useEffect(() => {
        if (updateStatus === "success") {
            dispatch(resetUpdateStatus());
        }
    }, [dispatch, updateStatus]);

    useEffect(() => {
        if (createStatus === "success") {
            dispatch(resetCreateStatus());
        }
    }, [dispatch, createStatus]);

    useEffect(() => {
        if (assignTagStatus === "success") {
            dispatch(resetAssignTagStatus());
        }
    }, [dispatch, assignTagStatus]);

    useEffect(() => {
        if (unassignedTagStatus === "success") {
            dispatch(resetUnassignedTagStatus());
        }
    }, [dispatch, unassignedTagStatus]);

    const tableColumns = getTableColumns();
    const tableData = getTableData({items});

    return (
        <>
            <SubHeader title="All Tags">
                <ActionButton
                    permissions={['BranchAdmin', 'BranchOwner']}
                    to="update"
                    className="btn-sm bg-primary bg-opacity-50">Sync to List</ActionButton>
                <ActionButton
                    permissions={['RestaurantAdmin', 'RestaurantOwner']}
                    to="add"
                    className="btn-sm bg-primary bg-opacity-50">Add new</ActionButton>
            </SubHeader>
            {fetchStatus === "loading" && <p>Loading...</p>}
            {fetchStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchStatus === "success" &&
                <Table className="mobile-responsive" columns={tableColumns} data={tableData} pagination={pagination}/>}
        </>
    );
};

export default TagView;
